const config = {
  //server_ip: "http://localhost:4000/",
  //server_ip: "https://usfanapi.phormuladev.com/",
  server_ip: "https://apiv2.usf-an.pt/",
};

export default config;
